export { default as EntityPaperFrame } from './EntityPaperFrame';
